import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		position: "sticky",
		top: 0,
		zIndex: 2,
	},
	tableContainer: {
		display: "flex",
		flexDirection: "column",
		...shorthands.overflow("scroll"),
		height: "calc(100% - 35px)",
	},
	tableHeaderCell: {
		backgroundColor: tokens.colorNeutralBackground1Hover,

		"&:hover, &:hover:active": {
				backgroundColor: tokens.colorNeutralBackground1Hover,
			},
	},
	additionalActionButton: {
		paddingRight: "0px",
		paddingLeft: "0px",
		minWidth: 0,
	},
});
